import {useHistory, useRouteMatch} from "react-router";
import React, {useEffect, useRef, useState} from "react";
import {useArticulosService, useHojasDeRutaService} from "services/hooks";
import {useSnackbar} from "notistack";
import {Button, Divider} from "@material-ui/core/index";
import {CardArticulo} from "components/picking/components/card.articulo";
import {CardHeader} from "components/picking/components/card.header";
import {ScanResultDialog} from "components/picking/components/scan.result.dialog";
import {useConfirm} from 'material-ui-confirm';
import Typography from "@material-ui/core/Typography";
import {ScanReceptor} from "components/picking/components/scan.receptor";
import {canCompleteScans, removeArticulosEspeciales} from "../../../assets/utils";
import {ManualScan} from "../components/manual.scan";
import {ItemActionsDialog} from "components/picking/components/item.actions.dialog";

export function ScanArticulosView() {
    const [articulos, _setArticulos] = useState([]);
    const [scanResult, setScanResult] = useState({dialogOpen: false, found: false, articulo: undefined});
    const [itemActions, setItemActions] = useState({dialogOpen: false, articulo: undefined});
    const scanActive = useRef(true);

    const history = useHistory();
    const match = useRouteMatch();
    const {enqueueSnackbar} = useSnackbar();
    const confirm = useConfirm();

    const HojasDeRutaService = useHojasDeRutaService();
    const ArticulosService = useArticulosService();

    const articulosRef = React.useRef(articulos);

    const setArticulos = articulos => {
        articulosRef.current = articulos;
        _setArticulos(articulos);
    }

    useEffect(() => {
        HojasDeRutaService.getArticulosById(
            match.params.idHojaDeRuta,
            response => {
                const articulos = removeArticulosEspeciales(response.data.result);
                setArticulos(articulos.map(articulo => ({...articulo, scanned: 0})));
            },
            error => enqueueSnackbar(error, {variant: 'error'})
        );
    }, []);

    const findScannedArticulo = (scannedCode) => {
        return new Promise((resolve, reject) => {
            ArticulosService.getByBarcode(
                scannedCode,
                success => resolve(success.data.count > 0 ? success.data.result : undefined),
                error => enqueueSnackbar(error, {variant: 'error'})
            )
        })
    }

    const onScanCode = async (scannedCode) => {
        let scannedArticulo = await findScannedArticulo(scannedCode);
        scannedArticulo = articulosRef.current.find(articulo => (articulo.id === scannedArticulo?.id));

        if (scannedArticulo) {
            scannedArticulo.scanned++;
            setArticulos(articulosRef.current);
        }

        setScanResult({
            dialogOpen: true,
            found: !!scannedArticulo,
            scannedCode: scannedCode,
            articulo: scannedArticulo
        });
    };

    const onFinishCollect = () => {
        const notScanned = articulos.filter(articulo => !articulo.scanned);

        const navBack = () => history.push(`/picking/recolectarArticulos`);

        if (notScanned.length > 0) {
            confirm({
                title: '¿Seguro de terminar?',
                // description: '¿Seguro de terminar la recolección?',
                content: <div>
                    Hay <Typography component={"span"} variant={"body2"} color={"primary"} align={"right"}>
                    <b>{notScanned.length}</b>
                </Typography> artículos sin escanear.
                </div>,
                confirmationText: 'Terminar',
                cancellationText: 'Cancelar'
            })
                .then(() => {
                    navBack();
                })
                .catch(() => {
                });
        } else
            navBack();
    }

    const closeResultDialog = () => setScanResult(prev => ({...prev, dialogOpen: false}));

    const closeItemActionsDialog = () => setItemActions(prev => ({...prev, dialogOpen: false}));

    const onClickArticulo = (articulo) => {
        if (articulo.scanned > 0) {
            setItemActions({dialogOpen: true, articulo: articulo});
        }
    };

    const completeScans = articulo => {
        const articuloToUpdate = articulosRef.current.find(a => a.id === articulo.id);
        if (articuloToUpdate) {
            articuloToUpdate.scanned = parseInt(articuloToUpdate.cantidad);
            setItemActions(prevItemsActions => ({...prevItemsActions, articulo: articuloToUpdate}));
            setArticulos([...articulosRef.current]);
        }
    }

    const deleteScans = articulo => {
        const articuloToUpdate = articulosRef.current.find(a => a.id === articulo.id);
        if (articuloToUpdate) {
            articuloToUpdate.scanned = 0;
            setItemActions(prevItemsActions => ({...prevItemsActions, articulo: articuloToUpdate}));
            setArticulos([...articulosRef.current]);
        }
    }

    return (
        <>
            <ScanReceptor onScanCode={onScanCode} scanActive={scanActive}/>
            <div style={{height: window.innerHeight - 47, overflowY: 'auto'}}>
                <CardHeader
                    textLeft={<>Hoja de Ruta: <b>{match.params.idHojaDeRuta}</b></>}
                    textRight={
                        <>
                            <b>{articulos.length}</b> artículos
                            <ManualScan onScanCode={onScanCode} scanActive={scanActive}/>
                        </>
                    }
                />
                {articulos.map((articulo, index) =>
                    <>
                        <CardArticulo
                            key={index}
                            id={articulo.id}
                            detalle={articulo.detalle}
                            cantidad={articulo.cantidad}
                            scanned={articulo.scanned}
                            onClick={() => {
                                onClickArticulo(articulo);
                            }}
                        />
                        {index !== articulos.length - 1 && (
                            <Divider/>
                        )}
                    </>
                )}
                <Button
                    size={"medium"}
                    variant={"contained"}
                    className={'mt-2 mb-2'}
                    // disableElevation
                    color={"primary"}
                    fullWidth
                    style={{width: '90%', height: '3.5rem', margin: '0 5%'}}
                    onClick={() => {
                        onFinishCollect()
                    }}
                >
                    Terminar
                </Button>
            </div>
            <ScanResultDialog
                open={scanResult.dialogOpen}
                scanResult={scanResult}
                fullScreen
                onConfirm={() => {
                    closeResultDialog()
                }}
                confirmText={'Cerrar'}
            />

            <ItemActionsDialog
                open={itemActions.dialogOpen}
                articulo={itemActions.articulo}
                hideCompleteScans={!canCompleteScans(itemActions.articulo)}
                onCompleteScans={() => {
                    closeItemActionsDialog();
                    completeScans(itemActions.articulo);
                }}
                onDeleteScans={() => {
                    closeItemActionsDialog();
                    deleteScans(itemActions.articulo);
                }}
                onCancel={() => closeItemActionsDialog()}
                confirmText={'Cerrar'}
            />
        </>
    )
}
